import Box from "@mui/material/Box";
import { useCallback, useEffect, useState } from "react";
import { useSnackbar } from "notistack";
import AlertMessages from "common/Alert/AlertMessages";
import { useTranslation } from "react-i18next";
import Loader from "layout/Loader";
import BackendPaginationTable from "common/Table/TableWithPagination";
import { useNavigate, useParams } from "react-router-dom";
import EditIcon from "@mui/icons-material/Edit";
import ComponentHeaderTwo from "common/ComponentHeaderTwo/ComponentHeaderTwo";
import { ReactComponent as Business } from "../../../assets/SideBarIcons/business.svg";
import { useGetBusinessIntegrationService } from "subModule/src/services/business/useBusiness";
import IntegrationTabs from "./IntegrationTabs";
import DeleteIcon from "@mui/icons-material/Delete";
import { BusinessIntegrations } from "subModule/src/services/business/interface";
import { Grid, Typography } from "@mui/material";
import { BusinessProfileService } from "subModule/src/core/services";
import { Wrapper } from "subModule/src/type";
import FormDialog from "common/Modal/Modal";
import { useBusinessTabHeader } from "Helpers/useBusinessTabHeader";
// import ComponentSubheader from "common/ComponentHeaderTwo/ComponentSubheader";
// import ExtensionOutlinedIcon from "@mui/icons-material/ExtensionOutlined";

export default function IntegrationsListing() {
  const navigate = useNavigate();
  const params = useParams();
  const [openDeleteModal, setDeleteModal] = useState(false);
  const [row, setRow] = useState<BusinessIntegrations>({});
  const [loading, setLoading] = useState<boolean>(false);
  const {
    data: tableData,
    isRefetching,
    refetch,
  } = useGetBusinessIntegrationService(Number(params?.id));
  const { enqueueSnackbar } = useSnackbar();
  const { t } = useTranslation();
  const { breadcrumbItems } = useBusinessTabHeader(params?.id, "integrations");

  const fetchData = useCallback(() => {
    refetch().then((res: any) => {
      if (!res?.data?.success)
        enqueueSnackbar(
          <AlertMessages text={res?.data?.message || "Something went wrong"} />,
          { variant: "error" },
        );
    });
  }, []);

  useEffect(() => {
    fetchData();
  }, []);

  const onEdit = (row: any) =>
    navigate("/business/" + params?.id + "/integration/" + row.id);
  const showRowView = (row: any) =>
    navigate("/business/" + params?.id + "/integration/" + row.id);
  const onDelete = (row: any) => {
    setDeleteModal(true);
    setRow(row);
  };
  const actionslist = [
    { label: "edit", onClick: onEdit, icon: <EditIcon /> },
    { label: "delete", onClick: onDelete, icon: <DeleteIcon /> },
  ];
  return (
    <Box>
      <ComponentHeaderTwo
        showBtn={true}
        showSaveBtn={false}
        onClick={() => navigate("/businesses")}
        heading={t("Businessses")}
        icon={<Business className="text-black w-[30px] h-[30px]" />}
        btnText={"back"}
        btnType={"back"}
        showCreateBtn={true}
        createBtnText={"add"}
        onCreateClick={() =>
          navigate(`/business/${params?.id}/integration/add`)
        }
        breadcrumbItems={breadcrumbItems}
      />
      <Box className="flex">
        <IntegrationTabs params={params} selectedIndex={3} />
        <Box className="w-[100%] mt-[10px]">
          {/* <ComponentSubheader
            showBtn={true}
            showSaveBtn={false}
            onClick={() => navigate(`/business/${params?.id}/integration/add`)}
            heading={t("integrations")}
            icon={
              <ExtensionOutlinedIcon
                sx={{ fill: "#000", width: "30px", height: "30px" }}
              />
            }
            btnText={"add"}
            btnType={"create"}
            showCreateBtn={true}
          /> */}
          {isRefetching || loading ? (
            <Loader />
          ) : (
            <div id="mainListingTable" className="mt-[10px]">
              <BackendPaginationTable
                columns={[
                  { id: "title", label: "title", numeric: false, width: "50%" },
                  {
                    id: "integrationType",
                    label: "type",
                    numeric: false,
                    width: "35%",
                  },
                  {
                    id: "actions",
                    label: "actions",
                    numeric: false,
                    width: "15%",
                  },
                ]}
                data={tableData?.data || []}
                pageNo={1}
                pageSize={20}
                tableData={tableData || {}}
                showCheckbox={false}
                showActions={true}
                enableSorting={true}
                showHeader={false}
                showSearch={true}
                showFilter={true}
                showCreateButton={true}
                actions={actionslist}
                handleChangePage={() => {}}
                handleChangeRows={() => {}}
                rowClick={true}
                showRowView={showRowView}
                loadingSearch={false}
                headerComponent={<></>}
                hidePagination={true}
              />
            </div>
          )}
        </Box>
      </Box>
      {openDeleteModal && (
        <FormDialog
          open={openDeleteModal}
          onClose={() => setDeleteModal(false)}
          title={t("delete") + " " + t("ACCOUNT")}
          content={
            <Grid container>
              <Grid item xs={12}>
                <Typography>{t("Are you sure you want to delete?")}</Typography>
              </Grid>
            </Grid>
          }
          saveFunction={() => {
            setDeleteModal(false);
            setLoading(true);
            BusinessProfileService.deleteBusinesIntegration((row as any).id)
              .then((response: Wrapper) => {
                if (response.success) {
                  refetch();
                  enqueueSnackbar(
                    <AlertMessages
                      statusCode={response.status}
                      text={t("deleted") + " " + t("successfully")}
                    />,
                    { variant: "success" },
                  );
                } else {
                  enqueueSnackbar(
                    <AlertMessages statusCode={response.status} />,
                    { variant: "error" },
                  );
                }
              })
              .catch((err: any) => {
                console.error("===", err);
                enqueueSnackbar(
                  <AlertMessages
                    text={err?.data?.message || err || "Something went wrong"}
                  />,
                  { variant: "error" },
                );
              })
              .finally(() => setLoading(false));
          }}
          submitButtonText="Delete"
        />
      )}
    </Box>
  );
}
